import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltUp, faLongArrowAltDown, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Utility from '../../../../GlobalModules/Utility/Utility';

const MetricCardWithComparison = ({ title, value, difference, isLoading, currency = '', iscurrencyAdd = true }) => {
  // Determine if difference is positive, negative, or zero
  const differenceSign = difference > 0 ? 1 : (difference < 0 ? -1 : 0);
  
  return (
    <div className="col-12 p-3 bg-white rounded custom-border-light h-100">
      <div className="d-flex align-items-center flex-column box-content">
        <div className="text-subhead p-2">{title}</div>

        <div className="mt-auto p-2">
          {isLoading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            <div className="d-flex flex-column align-items-center">
              <span className="text-headline d-block mb-1">
                  { iscurrencyAdd ? Utility.formatCurrencyValue(value) : value}
              </span>
              {differenceSign !== 0 && (
                <span className={`${differenceSign === 1 ? 'text-success' : 'text-danger'}`}>
                  {differenceSign === 1 ? (
                    <FontAwesomeIcon icon={faLongArrowAltUp} />
                  ) : (
                    <FontAwesomeIcon icon={faLongArrowAltDown} />
                  )}
                  {' '}{Math.abs(difference)}%
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricCardWithComparison;
